import * as ActionTypes from "./ActionTypes";
import axios from "axios";

export const setTourismEvents = events => {
  return {
    type: ActionTypes.LOAD_TOURISMEVENTS,
    events: events
  };
};

export const onCreateTourismEvent = response => {
  return {
    type: ActionTypes.CREATE_TOURISMEVENT,
    response: response
  };
};

export const onDeleteTourismEvent = response => {
  return {
    type: ActionTypes.DELETE_TOURISMEVENT,
    response: response
  };
};

export const onUpdateTourismEvent = response => {
  return {
    type: ActionTypes.MODIFY_TOURISMEVENT,
    response: response
  };
};

export const loadTourismEvents = () => {
  return dispatch => {
    axios
      .get("http://190.105.227.203/baroloapi/tourism")
      .then(response => {
        dispatch(setTourismEvents(response.data));
      })
      .catch(error => {});
  };
};

export const createTourismEvent = tourismEvent => {
  return dispatch => {
    axios
      .post("http://190.105.227.203/baroloapi/createeventtourism", tourismEvent)
      .then(response => {
        dispatch(onCreateTourismEvent(response.data));
      })
      .catch(error => {
        console.log(error);
      })
     
  };
};

export const deleteTourismEvent = idTourismEvent => {
  return dispatch => {
    axios
      .delete(
        "http://190.105.227.203/baroloapi/deleteeventtourism/" + idTourismEvent
      )
      .then(response => {
        dispatch(onDeleteTourismEvent(response.data));
      })
      .catch(error => {
        console.log(error);
      })
     
  };
};

export const updateTourismEvent = tourismEvent => {
  return dispatch => {
    axios
      .put("http://190.105.227.203/baroloapi/updateeventtourism", tourismEvent)
      .then(response => {
        dispatch(onUpdateTourismEvent(response.data));
      })
      .catch(error => {
        console.log(error);
      })
    
  };
};
